import React from 'react';
import { Button } from '@/components/ui/button';
import { ArrowRight } from 'lucide-react';

interface HomeHeroProps {
  onCTA: () => void;
}

const HomeHero = ({ onCTA }: HomeHeroProps) => {
  return (
    <section className="min-h-screen flex items-center justify-center px-6 py-24 pt-32 bg-[var(--page-bg)]">
      <div className="max-w-4xl mx-auto text-center">
        <h1 className="text-[24px] font-semibold text-[var(--text-primary)] mb-6 md:mb-8 tracking-normal leading-[1.1] animate-fade-in">
          Hire better.{' '}
          <span className="text-[var(--accent-hex)]">
            Backed by data.
          </span>
        </h1>

        <p className="text-[16px] text-[var(--text-secondary)] mb-10 md:mb-12 max-w-2xl mx-auto leading-relaxed font-normal animate-fade-in" style={{ animationDelay: '0.1s' }}>
          Scientifically-validated assessments.{' '}
          <span className="text-[var(--accent-hex)] font-medium">
            AI-powered insights.
          </span>{' '}
          10 minutes.
        </p>

        <div className="animate-fade-in" style={{ animationDelay: '0.2s' }}>
          <Button
            onClick={onCTA}
            size="lg"
            className="h-12 md:h-14 px-8 md:px-10 text-[13px] font-semibold bg-[var(--accent-hex)] hover:bg-[var(--accent-hover)] text-white rounded-lg transition-all duration-200"
          >
            Get Started
            <ArrowRight className="ml-2 h-4 md:h-5 w-4 md:w-5" />
          </Button>

          <p className="text-[11px] text-[var(--text-muted)] mt-4">
            No credit card required • Results in 10 minutes
          </p>
        </div>
      </div>
    </section>
  );
};

export default HomeHero;
